import { TChartDataMetric } from '@sparkplug/lib';

export const VENDOR_MARKET_CHART_METRIC_OPTIONS: TChartDataMetric[] = [
    'total_units',
    'total_sales',
];
